import { BarChart3, TrendingUp } from "lucide-react";
import ProgressBar from "./ProgressBar";

const performanceAnalyticsData = [
  {
    title: "App Downloads",
    isProfit: true,
    percent: 12,
    no: 2400,
    progressPercent: 40,
  },
  {
    title: "Active Users",
    isProfit: true,
    percent: 8,
    no: 1800,
    progressPercent: 65,
  },
  {
    title: "Revenue",
    isProfit: true,
    percent: 24,
    no: 1240,
    progressPercent: 85,
  },
  {
    title: "API User",
    isProfit: true,
    percent: 34,
    no: 1499,
    progressPercent: 40,
  },
  {
    title: "White Label",
    isProfit: true,
    percent: 34,
    no: 1499,
    progressPercent: 40,
  },
  {
    title: "CRM User",
    isProfit: true,
    percent: 34,
    no: 1499,
    progressPercent: 30,
  },
];

export default function PerformanceAnalytics() {
  return (
    <div className="w-full max-w-md bg-white p-1">
      <div className="flex items-center gap-3">
        <div className="bg-pink-400 p-2 rounded-md">
          <BarChart3 className="w-5 h-5 text-white" />
        </div>
        <h1 className="text-[14px]">Performance</h1>
      </div>

      <div className="flex flex-col justify-center items-center my-1 gap-[2px] w-full p-2">
        {performanceAnalyticsData.map(
          ({ title, isProfit, percent, no, progressPercent }, index) => (
            <div key={index} className="flex flex-col justify-center w-full">
              <div className="flex items-center justify-between gap-8">
                <span className="text-gray-700 font-[500] text-[11px]">
                  {title}
                </span>
                <div
                  className={`flex items-center gap-1 p-[2px] rounded text-[12px] ${
                    isProfit
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}
                >
                  <TrendingUp
                    className={`w-4 h-4 ${
                      isProfit ? "text-green-700" : "text-red-700"
                    }`}
                  />
                  <span className="text-sm font-semibold text-[12px]">
                    {isProfit ? "+" : "-"}
                    {percent}%
                  </span>
                </div>
              </div>

              <div className="flex items-center justify-between my-1 gap-6">
                <h1 className="font-semibold text-md">
                  {(no / 1000).toFixed(2)}K
                </h1>
                <div className="flex items-center w-full gap-1">
                  <ProgressBar progress={percent} color="yellow-500" />
                  <span className="text-sm font-[500]">{progressPercent}%</span>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
}
